import { LoadableAfterPaint } from '@confluence/loadable';

export const UnreadTooltipText = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-UnreadTooltipText" */ '../src/UnreadTooltipText.tsx'))
			.UnreadTooltipText,
});
